import { scrollTo } from "../functions/animation";

let scrollPositionTop = window.scrollY,
    lastScrollTop = 0,
    scrollTimeout = null, 
    headerSticky = document.querySelector('.site-header'),
    mobileMenu = document.getElementById('site-navigation'),
    mobileMenuSide = mobileMenu.querySelector('.side-menu'),
    isScrolling;

let btnDecouvrir = document.getElementById('megamenu-decouvrir'),
    btnPreparer = document.getElementById('megamenu-preparer'),
    btnPratique = document.getElementById('megamenu-pratique'),
    btnBoutique = document.getElementById('megamenu-boutique');

//Fixed navbar after 500px 
window.addEventListener('scroll', function(){
    scrollPositionTop = window.scrollY;
    headerSticky.classList.add('is-fixed');

    if(scrollPositionTop >= 200){
        headerSticky.classList.add('scroll-fixed')
    } else {
        headerSticky.classList.remove('scroll-fixed');
    }
})

//Scroll up effect
window.addEventListener('scroll', function(){
    
    if(!headerSticky.classList.contains('scroll-fixed')) {
        return;
    }

    let st = window.pageYOffset || document.documentElement.scrollTop;
    document.querySelector('.menu-decouvrir > .megamenu').classList.remove('menu-active');
    document.querySelector('.menu-preparer > .megamenu').classList.remove('menu-active');
    document.querySelector('.menu-pratique > .megamenu').classList.remove('menu-active');
    document.querySelector('.menu-boutique > .megamenu').classList.remove('menu-active');

    if (st > lastScrollTop){
        // downscroll code
        headerSticky.classList.remove('sticky');
        headerSticky.classList.add('stickyOff');
        

    } else if ((st - lastScrollTop) < -15) {
        // upscroll code
        headerSticky.classList.add('sticky');
        headerSticky.classList.remove('stickyOff');
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    
}, false)

const deactivateMegaMenu = () => {
    document.querySelectorAll('#site-menu > .megamenu > .megamenu').forEach(elem => {
        elem.classList.remove('menu-active')
    })
}

btnDecouvrir.addEventListener('click', function(){
    headerSticky.classList.add('sticky');
    headerSticky.classList.remove('stickyOff');
    deactivateMegaMenu()

    if(window.innerWidth < 1070) {
        mobileMenu.classList.add('active');
        scrollTo(mobileMenu.querySelector('.menu-decouvrir'), mobileMenuSide)
    } else {
        document.querySelector('.menu-decouvrir > .megamenu').classList.add('menu-active');
    }
})

btnPreparer.addEventListener('click', function(){
    headerSticky.classList.add('sticky');
    headerSticky.classList.remove('stickyOff');
    deactivateMegaMenu()

    if(window.innerWidth < 1070) {
        mobileMenu.classList.add('active');
        scrollTo(mobileMenu.querySelector('.menu-preparer'), mobileMenuSide)
    } else {
        document.querySelector('.menu-preparer > .megamenu').classList.add('menu-active');
    }
})

btnPratique.addEventListener('click', function(){
    headerSticky.classList.add('sticky');
    headerSticky.classList.remove('stickyOff');
    deactivateMegaMenu()

    if(window.innerWidth < 1070) {
        mobileMenu.classList.add('active');
        scrollTo(mobileMenu.querySelector('.menu-pratique'), mobileMenuSide)
    } else {
        document.querySelector('.menu-pratique > .megamenu').classList.add('menu-active');
    }
})

btnBoutique.addEventListener('click', function(){
    headerSticky.classList.add('sticky');
    headerSticky.classList.remove('stickyOff');
    deactivateMegaMenu()

    if(window.innerWidth < 1070) {
        mobileMenu.classList.add('active');
        scrollTo(mobileMenu.querySelector('.menu-boutique'), mobileMenuSide)
    } else {
        document.querySelector('.menu-boutique > .megamenu').classList.add('menu-active');
    }
})


 
